import { v4 as uuidv4 } from 'uuid';
import AuthAxios from "../../axios";
import { CombinedActionEnum } from '../../types/customLogger';


const getDeviceId = () => {
  let deviceId = localStorage.getItem('deviceId');
  if (!deviceId) {
    const uuid = uuidv4()
    deviceId = uuid
    localStorage.setItem('deviceId', deviceId)
  }

  return deviceId
}
export const userAnalytics = (action:CombinedActionEnum, pagePath: string) => {
  const deviceId = getDeviceId()
  AuthAxios.post('/analytics/activity', {
    deviceId,
    deviceInfo: {
      deviceId,
      deviceOs: 'web'
    },
    action,
    pageName: pagePath,
    pageId: uuidv4(),
  }).catch((err) => {
    console.error('userAnalytics', err)
  })
};
